import { render, staticRenderFns } from "./TypeBuffet.vue?vue&type=template&id=31657082&scoped=true&"
import script from "./TypeBuffet.vue?vue&type=script&lang=js&"
export * from "./TypeBuffet.vue?vue&type=script&lang=js&"
import style0 from "./TypeBuffet.vue?vue&type=style&index=0&id=31657082&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31657082",
  null
  
)

export default component.exports